<template>
  <div>
    <headerView></headerView>
    <div id="curpageWidth">
      <div v-loading="listLoading">
        <div
          v-for="(item, index) in pageModule"
          :key="index"
          style="position: relative"
          :ref="'pageItem'+index"
        >
          <component
            v-bind:is="item.ModuleName"
            v-bind:modata="item"
            type="preview"
            :phone-width="phoneWidth"
            :curpage-width="curpageWidth"
            :proportion="proportion"
            :animate-show="animateClas[index]"
            v-bind:index="index"
            :key="item.WID"
          ></component>
        </div>
      </div>
    </div>
    <el-empty :image-size="160" :description="$t('nodata')" v-if="stateSche==2 || stateSche==3"></el-empty>
    <footView v-if="stateSche!=1"></footView>
  </div>
</template>

<script>
import 'animate.css';//https://animate.style/  
import { getPage,getPageHome,getPageWxHome } from "@/request/api";

import hotpotModule from "@/components/Custom/Hotpot";
import mediumModule from "@/components/Custom/Medium";
import sliderModule from "@/components/Custom/Slider";
import spaceModule from "@/components/Custom/Space";
import textModule from "@/components/Custom/Text";
import videoModule from "@/components/Custom/Video";
 import courseModule from "@/components/Custom/Course";

export default {
  name: "",
  components: {
    hotpotModule,
    mediumModule,
    sliderModule,
    spaceModule,
    textModule,
    videoModule,
    courseModule
  },
  data() {
    return {
      pageID: "",
      stateSche: 1,
      listLoading: true,
      pageModule: null,
      
      phoneWidth: 0,
      curpageWidth: 1280,
      proportion:1,


      innerHeight:0,
      animateClas:[],
      itemBottom:[],
    };
  },
  mounted() {
   this.innerHeight=window.innerHeight;

    this.curpageWidth =document.getElementById("curpageWidth").offsetWidth - 17;
    //  if (this.$route.query) {
    //   this.pageID = this.$route.query.id || "";
    //   this.getDataList();
    // }
    this.pageID=this.$route.params && this.$route.params.id;
    this.getDataList();

  },
  created() {

  },
   beforeDestroy() {
     window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getDataList() {
      let that = this;
      that.stateSche = 1;
      that.listLoading = true;
      let handleGet;
    // this.$store.state.runenv=="miniprogram"
      if ((this.$route.query && this.$route.query.type=="wxpage")||(window.navigator && window.navigator.userAgent.indexOf("miniProgram")>=0)) {
        handleGet=getPageWxHome("");//微信小程序进入
      }else{
        handleGet=that.pageID?getPage("id=" + that.pageID):getPageHome("");
      }

      handleGet.then((res) => {
        that.listLoading = false;
        if (res.code == 200) {
          let data = res.data;
          let pageJson = data.pageJson ? JSON.parse(data.pageJson) : {};
          that.phoneWidth = pageJson.phoneWidth;

          that.proportion= Math.round((that.curpageWidth/that.phoneWidth) * 100) / 100;

          that.pageModule = pageJson.pageList || {};

          document.title = data.title;
          let metaInfo={
            keywords:data.seoKeyWord,
            description: data.seoDescription,
          };

          that.$store.commit("CAHNGE_META_INFO",metaInfo)

          that.$nextTick(()=>{
            that.pageModule.forEach((item,index)=>{
              that.itemBottom.push(this.$refs['pageItem'+index][0].offsetTop||0)
            })
            that.handleScroll();
          })
      
          window.addEventListener('scroll', this.handleScroll,true);

          that.stateSche = 0;
        } else if (res.code == 204) {
          that.pageModule = null;
          that.stateSche = 2;
        } else {
          that.pageModule = null;
          that.stateSche = 3;
        }
      });
    },

     handleScroll(){
       let that=this;
        let itemBottom=this.itemBottom;
        let len=itemBottom.length
        if(this.animateClas.length==len){
          window.removeEventListener('scroll', this.handleScroll);
          return
        }
        const seatNumb=(window.scrollY || document.documentElement.scrollTop)+this.innerHeight +20;
        for(let i=0;i<len;i++){
          if(itemBottom[i]<seatNumb){
            that.$set(that.animateClas,i,"animate")
          }
        }
    },


  },

  destroyed(){
   that.$store.commit("CAHNGE_META_INFO",{})
  },
};
</script>

<style scoped lang="scss">

</style>